import React, { useState, useEffect } from 'react';

const DinoEggDivision = () => {
  const problems = [
    { eggs: 48, dinos: 8 },
    { eggs: 56, dinos: 7 },
    { eggs: 72, dinos: 9 },
    { eggs: 30, dinos: 5 },
    { eggs: 24, dinos: 6 }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [fact, setFact] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const problem = problems[currentIndex];
  const correctAnswer = problem.eggs / problem.dinos;

  const [eggsPerNest, setEggsPerNest] = useState(0);

  useEffect(() => {
    setFeedback('');
    setFact('');
    setAnswer('');
    setShowNext(false);
    setDisabled(false);
    setEggsPerNest(0);
  }, [currentIndex]);

  const handleCheck = () => {
    const num = parseInt(answer);
    if (!num || num <= 0) {
      setFeedback('Please enter a positive number.');
      return;
    }
    if (num === correctAnswer) {
      setFeedback('Great! Correct answer.');
      setFact(`${problem.dinos} × ${correctAnswer} = ${problem.eggs}`);
      setShowNext(true);
      setDisabled(true);
      setEggsPerNest(correctAnswer);
    } else {
      setFeedback(`Try again! How many eggs per nest if total is ${problem.eggs} eggs and ${problem.dinos} dinos?`);
      setFact('');
    }
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % problems.length);
  };

  const styles = {
    body: {
      fontFamily: 'Comic Sans MS, cursive, sans-serif',
      background: '#d0f0c0',
      padding: 20,
      color: '#2a4d14',
      textAlign: 'center'
    },
    nestContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: 15,
      flexWrap: 'wrap',
      marginBottom: 20
    },
    nest: {
      width: 80,
      height: 80,
      background: '#f9f4c8',
      border: '4px solid #a67c00',
      borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
      position: 'relative',
      boxShadow: 'inset 0 8px 12px rgba(0,0,0,0.15)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    dino: {
      width: 60,
      marginBottom: 5,
      userSelect: 'none'
    },
    eggsContainer: {
      position: 'absolute',
      bottom: 12,
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: 3,
      maxWidth: 70
    },
    egg: {
      width: 14,
      height: 20,
      background: 'radial-gradient(circle at 8px 10px, #fff, #f2f2f2)',
      borderRadius: '50% 50% 60% 60%',
      border: '1.5px solid #c2b280',
      boxShadow: '0 2px 2px rgba(0,0,0,0.2)'
    },
    input: {
      fontSize: '1.2rem',
      width: 60,
      padding: 5,
      textAlign: 'center',
      border: '2px solid #a67c00',
      borderRadius: 6
    },
    button: {
      fontSize: '1.1rem',
      padding: '7px 15px',
      marginLeft: 10,
      border: 'none',
      borderRadius: 6,
      backgroundColor: '#a67c00',
      color: 'white',
      cursor: 'pointer'
    },
    feedback: {
      fontSize: '1.3rem',
      fontWeight: 'bold',
      minHeight: 30,
      marginTop: 10
    },
    fact: {
      fontStyle: 'italic',
      marginTop: 10,
      color: '#4a832c'
    }
  };

  return (
    <div style={styles.body}>
      <h1>Dino Egg Division 🦖</h1>
      <div>Help the dinos sit on their nests with equal eggs! How many eggs does each dino get?</div>
      <div style={{ fontSize: '1.4rem', fontWeight: 'bold', margin: '15px 0' }}>
        {problem.eggs} eggs and {problem.dinos} dinosaurs. How many eggs per dino?
      </div>

      <div style={styles.nestContainer}>
        {Array.from({ length: problem.dinos }).map((_, i) => (
          <div key={i} style={styles.nest}>
            <svg viewBox="0 0 64 64" style={styles.dino}>
              <circle cx="32" cy="32" r="30" fill="#6d995b" />
              <circle cx="22" cy="28" r="5" fill="#395a2a" />
              <circle cx="42" cy="28" r="5" fill="#395a2a" />
              <path d="M20 45 Q32 55 44 45" stroke="#395a2a" strokeWidth="3" fill="none" />
            </svg>
            <div style={styles.eggsContainer}>
              {Array.from({ length: eggsPerNest }).map((_, j) => (
                <div key={j} style={styles.egg}></div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div>
        <input
          type="number"
          placeholder="?"
          min="1"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          disabled={disabled}
          style={styles.input}
        />
        <button onClick={handleCheck} disabled={disabled} style={styles.button}>
          Check Answer
        </button>
        {showNext && (
          <button onClick={handleNext} style={styles.button}>
            Next Problem
          </button>
        )}
      </div>

      <div style={{ ...styles.feedback, color: feedback.includes('Correct') ? 'green' : 'red' }}>
        {feedback}
      </div>
      <div style={styles.fact}>{fact}</div>
    </div>
  );
};

export default DinoEggDivision;
